import { create } from "zustand";
import { persist } from "zustand/middleware";

export type AuthMethod = "email" | "entra-id";

interface AuthState {
  token: string | null;
  role: string | null;
  authMethod: AuthMethod | null;
  userEmail: string | null;
  setToken: (token: string, role: string, authMethod?: AuthMethod, email?: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      role: null,
      authMethod: null,
      userEmail: null,
      setToken: (token, role, authMethod = "email", email) =>
        set({ token, role, authMethod, userEmail: email || null }),
      logout: () => set({ token: null, role: null, authMethod: null, userEmail: null }),
    }),
    {
      name: "admin-auth-storage",
    }
  )
);
